import { createNames } from "@ace/web-components/dist_lib/utils";
export const getAceBettingBetButtonNames = (id) => {
    return createNames(id, 'ACE-BETTING-BET-BUTTON', '____LOCKED', '____INACTIVE', '____SELECTED', '____HORIZONTAL_LAYOUT', '____VERTICAL_LAYOUT', '____CARD_TYPE', '____FULL_WIDTH', '____WITH_ERROR', '____HAS_TENDENCY', 'LABEL', 'ODD', 'ODD__LABEL', 'LOCKED_ICON', 'INDICATOR_UP', 'INDICATOR_DOWN', 'TENDENCY');
};
//# sourceMappingURL=ace-betting-bet-button.get-names.js.map
